"use strict";
import { useState } from "react";
export default function useHoverProps() {
  const [hover, setHover] = useState(false);
  const hoverProps = { onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) };
  return [hover, hoverProps];
}
